/**
 * SmsService service is used to send sms request to jobs server.
 */
fx.service( class SmsService extends fx.Service {

    constructor(model)
    {
        super();
        this.model = model.creationModel;
        
        this._phoneNumber = undefined;
        this._qrCode = "";
    }

    get qrCode()
    {
        return this._qrCode;
    }    

    get phoneNumber()
    {
        return this._phoneNumber;
    }    

    set phoneNumber(phoneNumber)
    {
        this._phoneNumber = phoneNumber;
    }    

    start(){
        fx.service("SmsService").generateQrCode();
        this.repeat(this._checkUploadStatus, 10000);
    }

    generateQrCode(){
        this.smsAPI("get", null, this.model.creation.id, this._getQrCodeCallback);
    }

    send(phoneNumber, dialcode)
    {
        this.phoneNumber = phoneNumber;
        if (this.phoneNumber)
        {
            let url = "/app/uploader";
            this.post(
                url,
                {
                    action: "send",
                    phoneNumber: this._phoneNumber,
                    dialcode: dialcode,
                    bookId: this.model.creation.id
                }
            );
        }
    }

    _checkUploadStatus(){
        this.smsAPI("status", null, this.model.creation.id, this._checkUploadStatusCallback);
    }

    _getQrCodeCallback(data){
        this._qrCode = data.qrcode;
    }

    addPhotos(photos){
        this.repeat(this._checkUploadStatus, 60000);

        this.model.creation.photosort = 0;
        
        for(let i = 0; i < photos.length; i++ )
            this.model.photos.addItem( photos.getItemAt(i) );
    }

    _checkUploadStatusCallback(data){
        if(data.started)
        {
            this.model.event("mobile-upload-started", data);
        }

        if(data.finished)
        {
            if(data.photos)
                this.addPhotos(data.photos);
            
            this.model.event("mobile-upload-finished", data.photos);
        }
    }

    smsAPI(action, token, bookId, callback){
        this.post("/app/uploader",
        {
            action: action,
            token : token,
            bookId: bookId,
        }, callback);
    }

});

